<template>
  <div>
    <div
      v-if="tagsFarm.length < 1"
      class="text-center text-h6 text-grey-5 q-mt-lg"
    >
      No farm tags to display
    </div>
    <div
      v-for="(tagF, i) in tagsFarm"
      :key="tagF.tag_name"
      :class="i % 2 === 0 ? colorBlueGrey : colorGrey"
    >
      <div
        class="row items-center no-wrap q-py-sm q-px-sm cursor-pointer"
        @click="tagF.expand = !tagF.expand"
      >
        <div class="ellipsis">
          <q-icon name="home_work" size="xs" color="purple" class="q-mr-sm" />
          {{ tagF.farmName }}
        </div>
        <q-space />
        <div>
          <q-badge color="grey-8" class="q-mr-sm">
            {{ tagF.tags.length }}
          </q-badge>
        </div>
        <q-icon
          v-if="!tagF.expand"
          name="expand_more"
          size="md"
          :color="colorOrange"
        />
        <q-icon
          v-if="tagF.expand"
          name="expand_less"
          size="md"
          :color="colorOrange"
        />
      </div>
      <div v-if="tagF.expand && showOptions" class="col-12">
        <q-separator />
        <div class="row justify-center q-py-xs">
          <q-btn
            outline
            icon="delete"
            color="red-14"
            size="sm"
            padding="1px sm"
            class="q-mr-sm"
            @click="$emit('farmDeleteStart', tagF, 'farms')"
          />
          <q-btn
            outline
            icon="add"
            color="purple"
            size="sm"
            padding="1px sm"
            @click="$emit('farmAddStart', tagF, 'farms')"
          />
        </div>
      </div>
      <div v-if="tagF.expand" class="q-pl-md">
        <q-separator />
      </div>
      <div v-if="tagF.expand" class="col-12 row q-pl-md">
        <div
          v-for="tag in tagF.tags"
          :key="tag.tag_name + tag.farm_id"
          class="col-12 row items-center text-caption q-py-xs"
        >
          <q-icon name="sell" size="xs" :color="colorOrange" class="q-mr-sm" />
          {{ tag.tag_name }}
        </div>
      </div>
      <div v-if="tagF.expand" class="q-py-sm"></div>
    </div>
  </div>
</template>

<script>
import { decoder } from '@/lib/helpers';

export default {
  name: 'FarmTags',
  props: {
    tagsFarm: {
      type: Array,
      required: true
    },
    showOptions: {
      type: Boolean,
      required: true
    },
    farmList: {
      type: Array,
      required: true
    }
  },
  methods: {
    farmName(farmId) {
      const farm = this.farmList.find((x) => x.id === parseInt(farmId));
      return farm ? decoder(farm.farm_name) : '';
    },
    pondName(tag) {
      const farm = this.farmList.find((x) => x.id === parseInt(tag.farm_id));
      console.log(farm);
      const pond = farm.gps.ponds.find(
        (pond) => tag.pond_id === parseInt(pond.id)
      );

      return pond?.name ?? '---';
    },
    levelColor(tag) {
      return tag.tag_level === 0
        ? 'black'
        : tag.tag_level === 1
        ? 'green-14'
        : tag.tag_level === 2
        ? 'purple'
        : tag.tag_level === 3
        ? 'red-14'
        : tag.tag_level === 4
        ? 'orange-14'
        : tag.tag_level === 10
        ? 'primary'
        : 'grey';
    }
  },
  computed: {
    colorBlueGrey() {
      return this.$q.dark.isActive ? 'bg-blue-grey-10' : 'bg-grey-4';
    },
    colorGrey() {
      return this.$q.dark.isActive ? 'bg-grey-10' : 'bg-grey-5';
    },
    colorOrange() {
      return this.$q.dark.isActive ? 'orange-14' : 'orange-10';
    }
  }
};
</script>

<style scoped></style>
